let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("esYD7")).then(() => parcelRequire('inthu'));